import { WidgetConfig } from '@/types';

export const applyTheme = (config: WidgetConfig): void => {
  document.documentElement.style.setProperty('--primary', config.primaryColor);
  document.documentElement.style.setProperty('--secondary', config.secondaryColor);
};
